module.exports = __webpack_public_path__ + "img/woman_biking.6c3a8bb4.gif";